/**
 * Profile Page Module
 *  Author: Teemo
 *  CreatedAt: 2021-03-17
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { ActionType } from 'src/types/common/common';
import { ModuleType } from '../common';

import CollapseGroup from '@/src/components/CollapseGroup';
import LeftGreenBlock from 'src/components/DragContainers/LeftGreenBlock';
import {
  EDMBody,
  EDMHeader,
} from 'src/constrains/DraggableModules/ContentGroup/EDM';
import FeaturedProductsSection from 'src/constrains/SalesChannelPreviewPageComponents/FeaturedProductsSection';

import {
  getOrder,
  getState,
  moduleContentOnChange,
  onCollapseOpen,
} from '../slice';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { IParams } from '../../common';
import css from './css.less';

const Module = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const _params: IParams = useParams();
  const history = useHistory();
  const { contentUuid, saleChannelUuid } = _params;
  const order = useSelector(getOrder());

  const { collapseOpen } = useSelector(getState());

  const openList = order.map((item) => {
    if (collapseOpen[`module_${item.moduleType}`]) {
      return `module_${item.moduleType}`;
    }
  });

  const handleOnColorChange = (color, e, index) => {
    if (e) {
      e.stopPropagation();
    }
    _d(moduleContentOnChange({ type: ActionType.modify, index, data: color }));
  };

  const handleOnSort = (newIndex, oldIndex) => {
    _d(
      moduleContentOnChange({
        type: ActionType.reorder,
        data: { from: oldIndex, to: newIndex },
      }),
    );
  };

  const handleOnClickTitle = (draggableId) => {
    if (draggableId.length) {
      _d(onCollapseOpen({ idArr: [draggableId[0]] }));
    } else {
      _d(onCollapseOpen({ idArr: [] }));
    }
  };

  const onEdit = () => {
    history.push(
      `/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`,
    );
  };

  const collapseData = order.map((item, index) => {
    const draggableId = `module_${item.moduleType}`;
    const _open = collapseOpen[draggableId];
    const itemsDrop = {
      draggableId: draggableId,
      title:
        item.moduleType == ModuleType.FeaturedProduct ? (
          <LeftGreenBlock blockHeight={48}>
            <div className={css.edmHeader}>
              {getI18n('salesChannelContent.index.featuredProducts')}
            </div>
          </LeftGreenBlock>
        ) : (
          <EDMHeader />
        ),

      content:
        item.moduleType == ModuleType.FeaturedProduct ? (
          <FeaturedProductsSection
            handleOnColorChange={(color, e) =>
              handleOnColorChange(color, e, index)
            }
            onClick={onEdit}
            colour={item.titleTextColor}
          />
        ) : (
          <EDMBody />
        ),
      open: _open,
    };
    return itemsDrop;
  });

  return (
    <div>
      <CollapseGroup
        droppableId={'SalesChannelEditorProfilePage'}
        data={collapseData}
        openList={openList}
        onSort={handleOnSort}
        onClickTitle={handleOnClickTitle}
      />
    </div>
  );
};

export default Module;
